import cn from 'classnames'
import {ChangeEvent, FC, ReactNode} from 'react'

import {theme} from '@/theme/theme'

import {CheckboxMark} from '../common/icons/CheckboxMark'

type CheckboxInputProps = {
  label: string | ReactNode | null
  isChecked: boolean
  onChange: (e: ChangeEvent) => void
  textSize?: 'small' | 'medium'
  isDisabled?: boolean
  customIcon?: (isChecked: boolean, isDisabled: boolean) => ReactNode
}

export const CheckboxInput: FC<CheckboxInputProps> = ({
  label,
  isChecked,
  onChange,
  textSize,
  isDisabled,
  customIcon,
}) => (
  <>
    <label className={cn('label', isDisabled && 'disabled')}>
      <input
        data-test="Checkbox"
        type="checkbox"
        checked={isChecked}
        onChange={onChange}
        disabled={isDisabled}
      />
      <div className={cn('checkbox', textSize, label && 'with-label')}>
        {customIcon ? (
          customIcon(isChecked, Boolean(isDisabled))
        ) : (
          <CheckboxMark isChecked={isChecked} isDisabled={isDisabled} />
        )}
      </div>
      {label}
    </label>

    <style jsx>{`
      .label {
        display: inline-flex;
        cursor: pointer;
      }
      .disabled {
        cursor: default;
      }
      input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
        height: 0;
        width: 0;
      }
      .checkbox {
        border-radius: 4px;
      }
      input:focus-visible + .checkbox {
        outline: var(--focus-outline);
        outline-offset: 2px;
      }
      .with-label {
        margin-top: calc(${theme.spacing[1]} / 2);
        margin-right: ${theme.spacing[2]};
      }
      .small {
        margin-top: 0;
      }
    `}</style>
  </>
)
